module.exports = __webpack_public_path__ + "img/privilege7.bf0ddb5d.png";